/*
 * @Author: atdow
 * @Date: 2024-01-08 11:31:36
 * @LastEditors: null
 * @LastEditTime: 2025-09-22 18:49:36
 * @Description: file description
 */
import createAxios from '/@/utils/axios'

/**
 * 登录
 * @param data
 */
export function login (data: anyObj): ApiPromise {
  return createAxios({
    url: '/sys/user/login',
    data,
    method: 'POST'
  }) as ApiPromise
}

/**
 * 获取验证码
 * @param params
 */
export function getCodeImg (params: anyObj): Promise<Blob> {
  return createAxios({
    url: '/captcha',
    method: 'GET',
    params,
    responseType: 'blob'
  }) as Promise<Blob>
}

/**
 * 退出登录
 */
export function logout (): ApiPromise {
  return createAxios({
    url: '/sys/user/logout',
    method: 'GET'
  }) as ApiPromise
}

/**
 * 更新密码
 * @param data
 */
export function updatePwd (data: anyObj): ApiPromise {
  return createAxios({
    url: '/sys/user/updatePassword',
    method: 'POST',
    data
  }) as ApiPromise
}

/**
 * 旧瓴西登录
 * @param data
 * @link http://192.168.16.90:30310/receipt-lite/doc.html#/default/%E7%99%BB%E5%BD%95%E7%AE%A1%E7%90%86/webLoginUsingPOST
 */
export function oldLinkedTokenLogin (data: { oldLinkedToken: string }): ApiPromise {
  return createAxios({
    url: '/sys/user/login/oldLinked',
    data,
    method: 'POST'
  }) as ApiPromise
}
